import { FormSettingsType } from '../components/Form';
import * as yup from 'yup';

const validationSchema = yup.object().shape({
    code: yup.string()
        .required('REQUIRED')
        .min(3, 'MINLENGTH'),

    username: yup.string()
        .required('REQUIRED')
        .min(3, 'MINLENGTH')
        .email('EMAIL'),

    password: yup.string()
        .required('REQUIRED')
        .min(3, 'MINLENGTH'),

    passwordConf: yup.string()
        .oneOf([yup.ref('password'), null], 'PASSWORD_NOT_EQUAL')
        .required('REQUIRED')
        .min(3, 'MINLENGTH')
})

export const CodeForm: FormSettingsType = {
    validationSchema: validationSchema,
    submitButtonText: 'common.save',
    cancelButtonText: 'common.back',
    fields: [
        {
            type: 'text',
            name: 'code',
            label: 'form.labels.code',
            className: 'auth-style',
        },
        {
            type: 'text',
            name: 'username',
            label: 'form.labels.email',
            className: 'auth-style',
        },
        {
            type: 'password',
            name: 'password',
            label: 'form.labels.password',
            className: 'auth-style',
        },
        {
            type: 'password',
            name: 'passwordConf',
            label: 'form.labels.passwordConf',
            className: 'auth-style',
        },
    ],
};
